import AdsService from '@/api/client/ads.service'

export default {
  state: {
    data: {},
  },
  getters: {
    getCompanionAdObject: state => state.data,
  },
  actions: {
    async getCompanionAd({ commit }, params) {
      const adFormats = await AdsService.getAd(params.adId, params.adGroupId, params.catalogSetId, params.accountId)
      commit('SET_COMPANION_AD', adFormats)
    },
  },
  mutations: {
    SET_COMPANION_AD(state, adFormats) {
      state.data = adFormats
    },
  },
}
